import { useState, useEffect, useRef } from "react";
import { Col, Row, Container } from "react-bootstrap";
import Layout from "@/components/layout";
import styles from "@/styles/AboutUs.module.css";
import { healerServices } from "@/services/healerServices";
import Head from "next/head";
import Link from "next/link";

const TermsAndConditions = (props) => {
  const [termsAndConditions, setTermsAndConditions] = useState(
    props?.termsAndConditions ?? {}
  );
  const [showSideButton, setShowSideButton] = useState(false);
  const firstSectionRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      if (!firstSectionRef.current) return;

      const sectionTop = firstSectionRef.current.getBoundingClientRect().bottom;

      setShowSideButton(sectionTop < 0);
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  //const [apiLoader, setApiLoader] = useState(true);

  //   const fetchTermsAndConditions = async () => {
  //     const res = await healerServices.getTermsAndConditions();
  //     setApiLoader(false);
  //     if (res.status) {
  //       setTermsAndConditions(res.data);
  //     } else {
  //         toast.error(res.message, {
  //             autoClose: 5000,
  //         });
  //     }
  // };

  // useEffect(() => {
  //   fetchTermsAndConditions();
  // }, []);

  return (
    <>
      <>
        <Head>
          <title>{termsAndConditions?.meta?.og_title}</title>
          <meta
            name="title"
            content={termsAndConditions?.meta?.meta_title}
          ></meta>
          <meta
            name="description"
            content={termsAndConditions?.meta?.meta_description}
          ></meta>
          <meta
            name="keywords"
            content={termsAndConditions?.meta?.meta_keywords}
          ></meta>
          <meta property="og:type" content="website"></meta>
          <meta
            property="og:title"
            content={termsAndConditions?.meta?.og_title}
          ></meta>
          <meta
            property="og:image"
            content={termsAndConditions?.meta?.og_image}
          ></meta>
          <link
            rel="canonical"
            href="https://www.zenkify.com/terms-and-conditions"
          ></link>
          <meta
            property="og:description"
            content={termsAndConditions?.meta?.meta_description}
          ></meta>
          <meta name="twitter:card" content="summary_large_image" />
          <meta
            name="twitter:title"
            content={termsAndConditions?.meta?.meta_title}
          />
          <meta
            name="twitter:description"
            content={termsAndConditions?.meta?.meta_description}
          />
          <meta
            name="twitter:image"
            content={termsAndConditions?.meta?.og_image}
          />
          <meta
            property="og:url"
            content="https://www.zenkify.com/terms-and-conditions"
          />
          <meta property="og:site_name" content="Zenkify" />
          <meta
            property="og:image:alt"
            content="zenkify terms and conditions"
          />
          <meta
            property="og:image"
            content={termsAndConditions?.meta?.og_image}
          ></meta>
        </Head>
        <section
          ref={firstSectionRef}
          className={`${styles["section-banner"]} ${styles["banner-page"]}`}
          style={{ background: "url(/images/about-banner.jpg)" }}
        >
          <Container>
            <Row>
              <Col md={8} className="m-auto">
                <div className={styles["inner-content"]}>
                  <h2 className={styles["banner-title"]}>
                    Terms and Conditions
                  </h2>
                  <p>
                    Welcome to Zenkify. Your use of our services constitutes
                    acceptance of our terms and conditions. We are committed to
                    maintaining a respectful and secure environment within our
                    healing community, dedicated to your well-being.
                  </p>
                </div>
              </Col>
            </Row>
          </Container>
        </section>
        <section className="privacy-policy-sec">
          <Container>
            <Row>
              <Col md={12} className="mb-3"></Col>
              <Col md={12} className="mb-3">
                {termsAndConditions?.description ? (
                  <div
                    dangerouslySetInnerHTML={{
                      __html: termsAndConditions?.description,
                    }}
                  />
                ) : (
                  <p>Not Specified.</p>
                )}
              </Col>
            </Row>
          </Container>
        </section>
        <Link
          id="floatingBook"
          className="floating-book"
          aria-label="Book a FREE call now"
          href="/healers"
          style={{ opacity: showSideButton ? 1 : 0 }}
        >
          Book a FREE call now
        </Link>
      </>
    </>
  );
};

export default TermsAndConditions;

TermsAndConditions.getLayout = function getLayout(page) {
  return <Layout>{page}</Layout>;
};

// ssr
export async function getServerSideProps() {
  const fetchTermsAndConditions = async () => {
    try {
      const res = await healerServices.getTermsAndConditions();
      if (res.status) {
        return res.data;
      }
    } catch (error) {
      console.error("Error fetching slider data:", error);
    }
  };

  const termsAndConditions = (await fetchTermsAndConditions()) ?? {};

  // Pass data to the page via props
  return { props: { termsAndConditions } };
}
